const tuple = (...args) => args;

export { tuple };
//# sourceMappingURL=tuple.js.map
